// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"G2-z","colorTextValue":"H2-z","swatches":"I2-z","collapseLink":"J2-z","isCollapsed":"K2-z","dropdown":"L2-z","disabled":"M2-z"};